/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { useCallback } from "react";
import { useAppDispatch, useRootState } from ".";
import { PRODUCT_ITEM_TYPE } from "../api/appApi";
import {
  trunkGetAppLoginPage,
  trunkDoAppLogout,
  trunkGetAppLoginInfo,
  trunkGetDropboxList,
  trunkGetDriveFolderList,
  trunkUploadDropboxToEco,
  trunkUploadEcoToDrive,
  trunkChangeDriveSort,
} from "../store/app";
import { DriveListReqeust } from "../../types/app";

// # hooks
const useAppStore = () => {
  const dispatch = useAppDispatch();

  const appState = useRootState((state) => state.appStore);

  const boundGetAppLoginPage = useCallback(
    (snsType: PRODUCT_ITEM_TYPE) =>
      dispatch(trunkGetAppLoginPage(snsType)).then(),
    [dispatch]
  );
  const boundDoAppLogout = useCallback(
    (snsType: PRODUCT_ITEM_TYPE) => dispatch(trunkDoAppLogout(snsType)).then(),
    [dispatch]
  );
  const boundGetAppLoginInfo = useCallback(
    (snsType: PRODUCT_ITEM_TYPE) =>
      dispatch(trunkGetAppLoginInfo(snsType)).then(),
    [dispatch]
  );
  const boundGetDropboxList = useCallback(
    (req: DriveListReqeust) => dispatch(trunkGetDropboxList(req)).then(),
    [dispatch]
  );
  const boundGetDriveFolderList = useCallback(
    (req: { type: PRODUCT_ITEM_TYPE; folder: string }) =>
      dispatch(trunkGetDriveFolderList(req)).then(),
    [dispatch]
  );
  const boundUploadDropboxToEco = useCallback(
    (req: {
      fileId: string;
      uid: string;
      setProgressPercent?: any;
      name: string;
    }) => dispatch(trunkUploadDropboxToEco(req)).then(),
    [dispatch]
  );
  const boundUploadEcoToDrive = useCallback(
    (req: {
      type: "google" | "dropbox";
      syncId: string;
      revisionNo: number;
      targetFolder?: string;
    }) => dispatch(trunkUploadEcoToDrive(req)).then(),
    [dispatch]
  );
  const boundChangeDriveSort = useCallback(
    (sort: "date" | "datedesc" | "file" | "filedesc") =>
      dispatch(trunkChangeDriveSort(sort)).then(),
    [dispatch]
  );
  return {
    appState,
    getAppLoginPage: boundGetAppLoginPage,
    getAppLoginInfo: boundGetAppLoginInfo,
    uploadDropboxToEco: boundUploadDropboxToEco,
    uploadEcoToDrive: boundUploadEcoToDrive,
    getDropboxList: boundGetDropboxList,
    getDriveFolderList: boundGetDriveFolderList,
    doAppLogout: boundDoAppLogout,
    changeDriveSort: boundChangeDriveSort,
  };
};

export default useAppStore;
